<script>
import axios from 'axios'
import optionsData from '../../assets/options/options.json'

export default {
  name: 'SplideComponent',
  data() {
    return {
      slides: null,
      options: {
        perPage: 3,         // Numero di slide per pagina
        arrows: true,       // Mostra le frecce
        pagination: true,   // Mostra la paginazione
        gap: '1rem',
        focus: 'center', // Spazio tra le slide
        breakpoints: {
          1200: {
            perPage: 3,    // 3 elementi per schermi larghi
          },
          800: {
            perPage: 2,    // 2 elementi affiancati per schermi medi
          },
          600: {
            perPage: 1,    // Un elemento centrale per schermi piccoli
          },
        },
      },
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      errorMessage: null
    }
  },
  methods: {
    getSlidesData() {
      axios
        .get(`/api/v1/eventi-in-evidenza?m=` + this.currentMonth + '&Y=' + this.currentYear)
        .then((response) => {
          if (response.status === 200 && response.statusText === 'OK') {
            if (response.data.data.length > 0) {
              this.errorMessage = null
              this.slides = response.data

              this.setSplideOptions()
            } else {
              this.slides = response.data
              this.errorMessage = response.data.error_message
            }
          }
        })
    },
    setSplideOptions() {
      this.options = optionsData
    },
    goToPreviousMonth() {
      if (this.currentMonth > 1) {
        this.currentMonth = this.currentMonth - 1
      } else {
        this.currentMonth = 12
        this.currentYear = this.currentYear - 1
      }
      this.getSlidesData()
    },
    goToNextMonth() {
      if (this.currentMonth < 12) {
        this.currentMonth = this.currentMonth + 1
      } else {
        this.currentMonth = 1
        this.currentYear = this.currentYear + 1
      }
      this.getSlidesData()
    }
  },
  mounted() {
    this.getSlidesData()
  }
}
</script>

<template>
  <div v-if="slides">
    <div class="card-header text-center bg-primary custom-card-header-border-radius d-flex align-items-center justify-content-center">
      <button class="btn" type="button" @click="goToPreviousMonth()">&lt;</button>
      <label class="fs-6 text-white fw-bold m-0 py-1">{{
        slides.month.label + ' ' + slides.Year
      }}</label>
      <button class="btn" type="button" @click="goToNextMonth()">></button>
    </div>
    <div v-if="errorMessage" class="text-center p-2">
      {{ errorMessage }}
    </div>
  </div>
  <Splide aria-labelledby="basic-example-heading" :options="options" v-if="slides">
    <SplideSlide v-for="(item , index) in slides.data" :key="item.nid">

      <div class="col h-100">
        <div class="card-wrapper shadow-sm rounded border border-light h-100">
          <div class="card no-after rounded d-flex flex-column h-100">
            <div class="img-responsive-wrapper">
              <div class="img-responsive img-responsive-panoramic">
                <figure class="img-wrapper">
                  <img

                    :src="item.image[0].url"
                    class="rounded-top img-fluid"
                    :title="item.image[0].alt"
                  >
                </figure>
                <div
                  class="card-calendar d-flex flex-column justify-content-center">
                  <span class="card-date">{{ item.d }}</span>
                  <span class="card-day">{{ item.F }}</span>
                </div>
              </div>
            </div>
            <div class="card-body flex-grow-1 d-flex flex-column justify-content-between">
              <div class="category-top">
                <a class="category text-decoration-none" :href="item.term.url">
                  {{ item.term.label}}
                </a>

              </div>
              <h3 class="card-title">
                <a class="text-decoration-none"
                    :href="item.url"
                   data-element="live-category-link">
                  {{ item.title }}
                </a>
              </h3>
              <p class="card-text text-secondary pb-3" v-html="item.description">
              </p>

              <a class="read-more t-primary text-uppercase"
                 :href="item.url"
                 aria-label="Leggi di più sulla pagina di Festival Arte di Strada">
                <span class="text">{{ item.read_more}}</span>
                <span class="visually-hidden"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </SplideSlide>
  </Splide>
  <button class="btn btn-primary" type="button"
          data-element="live-button-events"
          onclick="location.href='/vivere-il-comune/eventi';"
          data-focus-mouse="false"><span class="">Tutti gli eventi</span>
  </button>
</template>

<style scoped>
.custom-card-header-border-radius {
  border-radius: 4px 4px 0px 0px;
}
/* Altezza uniforme per tutte le card */
.splide__slide {
  display: flex;
  height: 100%; /* Lascia che Flexbox gestisca l'altezza */
  align-items: stretch; /* Allunga le slide per avere la stessa altezza */
}

.card-wrapper {
  height: 100%; /* Assicurati che il contenitore card riempia l'altezza disponibile */
}

.card {
  display: flex;
  flex-direction: column; /* Disposizione verticale del contenuto */
  height: 100%; /* Imposta l'altezza completa per tutte le card */
}

.card-body {
  flex-grow: 1; /* Fa in modo che il corpo della card si espanda per riempire lo spazio disponibile */
}

.read-more {
  margin-top: auto; /* Spinge il bottone "Leggi di più" in fondo alla card */
}
</style>
